export default function doRectsIntersect(rectA: DOMRect, rectB: DOMRect): boolean {
  return (
    rectA.left < rectB.right &&
    rectA.right > rectB.left &&
    rectA.top < rectB.bottom &&
    rectA.bottom > rectB.top
  );
}
